// ============================================================================
// SalaryProgression (F-756) — carte frise multi-series (lecture)
// ============================================================================
// Legende + chart. Le PoC exportait aussi un Panel INTERACTIF (F-777) consomme
// UNIQUEMENT par la CompensationSection self du Profil ; David a tranche de ne PAS
// toucher la vue self (le DTO self ne porte ni rate_history ni salary_history) ->
// le Panel interactif est hors scope de ce frag. La frise gestion, elle, a tout
// le DTO gestion et se rend ici.

import { useTranslation } from '../../i18n';
import { Card } from './ui';
import { SalaryProgressionChart } from './SalaryProgressionChart';
import type { SalaryTimeline } from '../../lib/salary/progression';

const LEGEND = [
  { key: 'salary', color: 'rgb(var(--brand-500-rgb))' },
  { key: 'bonus', color: 'var(--chart-cat-2)' },
  { key: 'benefits', color: 'var(--chart-cat-3)' },
] as const;

export function SalaryProgression({
  timeline,
  bonusByYear,
  bonusProjByYear,
  avantages,
  augGrillePct,
}: {
  timeline: SalaryTimeline;
  bonusByYear: Map<number, number>;
  bonusProjByYear?: Map<number, number>;
  avantages: { year: number; annual: number } | null;
  augGrillePct: number | null;
}) {
  const { t } = useTranslation();
  return (
    <Card>
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <span className="text-chip font-medium uppercase tracking-wide text-slate-400">{t('gest:management.progression.title')}</span>
        <ul className="flex flex-wrap items-center gap-3">
          {LEGEND.map((s) => (
            <li key={s.key} className="flex items-center gap-1.5 text-chip text-slate-500 dark:text-slate-400">
              <span aria-hidden className="inline-block size-2.5 rounded-full" style={{ backgroundColor: s.color }} />
              {t(`gest:management.chart.${s.key}`)}
            </li>
          ))}
        </ul>
      </div>
      <SalaryProgressionChart timeline={timeline} bonusByYear={bonusByYear} bonusProjByYear={bonusProjByYear} avantages={avantages} />
      <p className="mt-2 text-chip text-slate-500 dark:text-slate-400">
        {augGrillePct
          ? t('gest:management.progression.legendWithGrid', { echelon: timeline.maxEchelon, pct: Math.round(augGrillePct * 1000) / 10 })
          : t('gest:management.progression.legendFrozen', { echelon: timeline.maxEchelon })}
      </p>
    </Card>
  );
}
